import { module } from 'angular';

import { default as iadvizeServiceName, IAdvizeService } from './iadvize.service';

export default module('contact.agent.core.channel-digit.chat-iadvize', [])
  .run([iadvizeServiceName, () => {}])
  .service(iadvizeServiceName, IAdvizeService).name;
